import React from "react";
import { Divider } from "antd";
import { useSelector } from "react-redux";
import VarietiesTable from "../varieties/VarietiesTable";

function VarietiesStep({ handleNext, handleBack }) {
  const { activeObjProductionData } = useSelector((state) => ({
    activeObjProductionData: state.obj.activeObj["schemeProductionData"],
  }));

  const varieties = activeObjProductionData?.varieties;

  return (
    <>
      <VarietiesTable
        productionDataId={activeObjProductionData?.id}
        varieties={varieties}
      />

      <div className="sticky bottom-0 left-0 w-full bg-white">
        <Divider />
        <div className="flex justify-between mt-[1rem] gap-x-[1.25rem]">
          <div className="w-[100px]">
            <button
              type="button"
              key="back"
              onClick={handleBack}
              className="cstm-btn"
            >
              Back
            </button>
          </div>

          <div className="w-[100px]">
            <button
              onClick={handleNext}
              type="button"
              className="cstm-btn-2"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default VarietiesStep;
